module.exports = __webpack_public_path__ + "static/DarksideDetective3-68593d4e841a7b7bcc4a624cb0a5b708.webp";